var _g, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconFlagEs = function SvgIconFlagEs(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    stroke: "#E7E7E7"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 11.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 8.1,
    fill: "#D7D7D7",
    strokeWidth: 0.2
  }))), /*#__PURE__*/React.createElement("svg", _extends({
    x: 4,
    y: 4
  }, props), /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "M1 8c0 .856.153 1.677.438 2.434l6.562.61 6.562-.61a7 7 0 0 0 0-4.868L8 4.956l-6.562.61A7 7 0 0 0 1 8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M14.562 5.566A7 7 0 0 0 4.003 2.254a7 7 0 0 0-2.565 3.312zM1.438 10.434A7 7 0 0 0 8 15a7 7 0 0 0 6.562-4.566z"
  })))));
};
export { SvgIconFlagEs as ReactComponent };
export default "data:image/svg+xml;base64,Cgo8c3ZnIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIgoJeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CgkJPGNpcmNsZSBjeD0iMTIiIGN5PSIxMiIgcj0iMTEuNSIgc3Ryb2tlPSIjRTdFN0U3Ii8+CgkJPGNpcmNsZSBjeD0iMTIiIGN5PSIxMiIgcj0iOC4xIiBmaWxsPSIjRDdEN0Q3IiBzdHJva2U9IiNFN0U3RTciIHN0cm9rZS13aWR0aD0iLjIiLz4KICAgIDwvZz4KICAgIDxzdmcgeD0iNCIgeT0iNCI+CiAgICAgICA8c3ZnIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgdmlld0JveD0iMCAwIDE2IDE2IiBmaWxsPSJub25lIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aCBkPSJNMSA3Ljk5OTk5QzEgOC44NTYxMyAxLjE1MzEyIDkuNjc2NzIgMS40Mzc1IDEwLjQzNDRMNy45OTk5NyAxMS4wNDQ0TDE0LjU2MjQgMTAuNDM0NEMxNS4xNDU5IDguODYzOTIgMTUuMTQ1OSA3LjEzNjA2IDE0LjU2MjQgNS41NjU1OUw3Ljk5OTk3IDQuOTU1NjJMMS40Mzc1IDUuNTY1NTlDMS4xNDgxMyA2LjM0NDU4IDAuOTk5OTgyIDcuMTY4OTYgMSA3Ljk5OTk5WiIgZmlsbD0iI0ZGREE0NCIvPgo8cGF0aCBkPSJNMTQuNTYyNCA1LjU2NTU5QzE0LjA2NTIgNC4yMjU1MSAxMy4xNjk5IDMuMDY5NzcgMTEuOTk2NyAyLjI1MzYyQzEwLjgyMzYgMS40Mzc0NiA5LjQyODkxIDEgNy45OTk5NyAxQzYuNTcxMDMgMSA1LjE3NjMxIDEuNDM3NDYgNC4wMDMxOSAyLjI1MzYyQzIuODMwMDcgMy4wNjk3NyAxLjkzNDc1IDQuMjI1NTEgMS40Mzc1IDUuNTY1NTlIMTQuNTYyNFpNMS40Mzc1IDEwLjQzNDRDMS45MzQ3NSAxMS43NzQ1IDIuODMwMDcgMTIuOTMwMiA0LjAwMzE5IDEzLjc0NjRDNS4xNzYzMSAxNC41NjI1IDYuNTcxMDMgMTUgNy45OTk5NyAxNUM5LjQyODkxIDE1IDEwLjgyMzYgMTQuNTYyNSAxMS45OTY3IDEzLjc0NjRDMTMuMTY5OSAxMi45MzAyIDE0LjA2NTIgMTEuNzc0NSAxNC41NjI0IDEwLjQzNDRIMS40Mzc1WiIgZmlsbD0iI0Q4MDAyNyIvPgo8L3N2Zz4KCiAgICA8L3N2Zz4KICAgIAo8L3N2Zz4K";